import React, { SVGProps } from 'react';

const StarActiveIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_10003_6875)">
                <path
                    d="M0.663596 6.19973L2.4436 7.49973L1.7676 9.59323C1.65835 9.91793 1.65697 10.2692 1.76365 10.5948C1.87033 10.9203 2.07937 11.2027 2.3596 11.3997C2.63502 11.6031 2.96879 11.7121 3.31117 11.7104C3.65355 11.7087 3.98622 11.5964 4.2596 11.3902L6.0001 10.1092L7.7411 11.3887C8.01602 11.591 8.34799 11.7008 8.68928 11.7025C9.03057 11.7041 9.3636 11.5975 9.64048 11.398C9.91737 11.1985 10.1238 10.9163 10.2302 10.592C10.3366 10.2677 10.3375 9.91802 10.2326 9.59323L9.5566 7.49973L11.3366 6.19973C11.6112 5.99899 11.8153 5.71661 11.9198 5.39293C12.0243 5.06925 12.0238 4.72083 11.9184 4.39743C11.8131 4.07403 11.6082 3.7922 11.3331 3.59219C11.058 3.39218 10.7267 3.28422 10.3866 3.28373H8.2001L7.5366 1.21573C7.43226 0.890212 7.22723 0.60624 6.95108 0.404766C6.67493 0.203291 6.34193 0.0947266 6.0001 0.0947266C5.65826 0.0947266 5.32526 0.203291 5.04911 0.404766C4.77296 0.60624 4.56794 0.890212 4.4636 1.21573L3.8001 3.28373H1.6156C1.27547 3.28422 0.944192 3.39218 0.669086 3.59219C0.393981 3.7922 0.189117 4.07403 0.0837572 4.39743C-0.0216025 4.72083 -0.0220689 5.06925 0.0824248 5.39293C0.186918 5.71661 0.391027 5.99899 0.665596 6.19973H0.663596Z"
                    fill="#F2D74A"
                />
            </g>
            <defs>
                <clipPath id="clip0_10003_6875">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default StarActiveIcon;
